module.exports = "<div class=\"scaffold\"></div>\n<footer class=\"footer\">\n\t<abc-social-media-wrapper></abc-social-media-wrapper>\n</footer>"